import React from "react";
import PropTypes from "prop-types";
import { Modal, List, Avatar, Typography, Button, Space, Tag } from "antd";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

const UserSelectionModal = ({
  visible,
  users,
  onSelect,
  onCancel,
  loading = false,
}) => {
  const handleUserSelect = (user) => {
    onSelect(user);
  };

  const renderUserItem = (user) => (
    <List.Item
      actions={[
        <Button
          key={user.id}
          type="primary"
          icon={<CheckCircleOutlined />}
          onClick={() => handleUserSelect(user)}
        >
          Select User
        </Button>,
      ]}
    >
      <List.Item.Meta
        avatar={
          <Avatar
            size="large"
            icon={<UserOutlined />}
            style={{ backgroundColor: "#1890ff" }}
          />
        }
        title={
          <Space>
            <Text strong>{`${user.firstName || ""} ${
              user.lastName || ""
            }`}</Text>
            {user.isEmailVerified && (
              <Tag color="green" icon={<CheckCircleOutlined />}>
                Email Verified
              </Tag>
            )}
            {user.isMobileVerify && (
              <Tag color="blue" icon={<CheckCircleOutlined />}>
                Mobile Verified
              </Tag>
            )}
          </Space>
        }
        description={
          <Space direction="vertical" size="small">
            <Space>
              <MailOutlined />
              <Text>{user.email}</Text>
            </Space>
            {user.mobile && (
              <Space>
                <PhoneOutlined />
                <Text>{`${user.isd || ""} ${user.mobile}`}</Text>
              </Space>
            )}
            <Text type="secondary">ID: {user.id}</Text>
          </Space>
        }
      />
    </List.Item>
  );

  return (
    <Modal
      title={
        <div>
          <Title level={4} style={{ margin: 0 }}>
            Select User
          </Title>
          <Text type="secondary">
            Found {users.length} user(s) matching your search criteria
          </Text>
        </div>
      }
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
      ]}
      width={600}
      bodyStyle={{ maxHeight: "400px", overflow: "auto" }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Text>Searching for users...</Text>
        </div>
      ) : users.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Text type="secondary">No users found</Text>
        </div>
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={users}
          renderItem={renderUserItem}
          locale={{
            emptyText: "No users found",
          }}
        />
      )}
    </Modal>
  );
};

UserSelectionModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default UserSelectionModal;
